import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/starts-with";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

var _dec, _class, _class2, _temp;

import React from 'react';
import ReactDOM from 'react-dom';
import types from 'prop-types';
import { Manager, Popper, Reference } from 'react-popper';
import { styled, StyleSheet } from '@rexlabs/styling';
import { get, isFunction } from 'lodash';
export var BOUNDARIES = {
  VIEWPORT: 'viewport',
  WINDOW: 'window',
  SCROLL_PARENT: 'scrollParent'
};
export var PLACEMENTS = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end'
};

var getDimensions = function getDimensions(el) {
  return el ? window.getComputedStyle(el) : {};
};

var defaultStyles = StyleSheet({
  container: {
    position: 'relative'
  },
  wrapContent: {
    zIndex: 4
  },
  content: {
    transition: 'transform 200ms cubic-bezier(.165, .84, .44, 1)',
    position: 'relative',
    zIndex: 1
  },
  contentTop: {},
  contentBottom: {},
  contentLeft: {},
  contentRight: {}
});
var Tether = (_dec = styled(defaultStyles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tether, _React$Component);

  function Tether() {
    var _getPrototypeOf2, _context;

    var _this;

    _classCallCheck(this, Tether);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tether)).call.apply(_getPrototypeOf2, _concatInstanceProperty(_context = [this]).call(_context, args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "_refs", {});

    return _this;
  }

  _createClass(Tether, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _getDimensions = getDimensions(get(this._refs, 'target.firstChild')),
          width = _getDimensions.width,
          height = _getDimensions.height;

      var _getDimensions2 = getDimensions(get(this._refs, 'arrow.firstChild')),
          arrowWidth = _getDimensions2.width,
          arrowHeight = _getDimensions2.height;

      this.setState({
        width: width,
        height: height,
        arrowWidth: arrowWidth,
        arrowHeight: arrowHeight
      }, function () {
        return _this2.setState({
          offsetLeft: get(_this2._refs, 'target.firstChild.offsetLeft')
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _context2;

      var _this$props = this.props,
          Content = _this$props.Content,
          children = _this$props.children,
          distance = _this$props.distance,
          placement = _this$props.placement,
          autoFlip = _this$props.autoFlip,
          preventOverflow = _this$props.preventOverflow,
          boundary = _this$props.boundary,
          offset = _this$props.offset,
          arrowMargin = _this$props.arrowMargin,
          Arrow = _this$props.Arrow,
          isClosing = _this$props.isClosing,
          s = _this$props.styles,
          target = _this$props.target;
      var _this$state = this.state,
          arrowWidth = _this$state.arrowWidth,
          arrowHeight = _this$state.arrowHeight;
      var arrowPosition = {
        width: arrowWidth,
        height: arrowHeight,
        margin: arrowMargin
      }; // Mapping our props to react-popper "modifiers" (aka plugins).

      var modifiers = {
        flip: {
          enabled: autoFlip,
          boundariesElement: boundary
        },
        offset: {
          enabled: true,
          offset: _concatInstanceProperty(_context2 = "".concat(offset, ", ")).call(_context2, distance)
        },
        preventOverflow: {
          enabled: preventOverflow,
          boundariesElement: boundary
        },
        hide: {
          enabled: preventOverflow
        }
      };
      return React.createElement(Manager, null, React.createElement(Reference, null, function (_ref) {
        var ref = _ref.ref;
        return isFunction(children) ? children({
          ref: ref
        }) : React.createElement("div", {
          ref: ref
        }, children);
      }), ReactDOM.createPortal(React.createElement(Popper, {
        placement: placement,
        modifiers: modifiers
      }, function (_ref2) {
        var popperPlacement = _ref2.placement,
            ref = _ref2.ref,
            style = _ref2.style,
            arrowProps = _ref2.arrowProps;
        var actualPlacement = popperPlacement || placement;
        return React.createElement("div", _extends({
          ref: ref,
          style: style
        }, s('wrapContent'), {
          "data-placement": actualPlacement
        }), React.createElement("div", s('content', {
          opening: !isClosing,
          closing: isClosing,
          openingTop: !isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'top'),
          openingBottom: !isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'bottom'),
          openingLeft: !isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'left'),
          openingRight: !isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'right'),
          closingTop: isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'top'),
          closingBottom: isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'bottom'),
          closingLeft: isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'left'),
          closingRight: isClosing && _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'right'),
          contentTop: _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'top'),
          contentBottom: _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'bottom'),
          contentLeft: _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'left'),
          contentRight: _startsWithInstanceProperty(actualPlacement).call(actualPlacement, 'right')
        }), !!Arrow && React.createElement(Arrow, {
          placement: actualPlacement,
          arrowProps: arrowProps,
          arrowPosition: arrowPosition
        }), React.createElement(Content, {
          placement: popperPlacement || placement
        })));
      }), target));
    }
  }]);

  return Tether;
}(React.Component), _defineProperty(_class2, "propTypes", {
  boundary: types.oneOf(_Object$values(BOUNDARIES)),
  placement: types.oneOf(_Object$values(PLACEMENTS)).isRequired,
  distance: types.string,
  offset: types.string,
  autoFlip: types.bool,
  preventOverflow: types.bool,
  arrow: types.node,
  arrowMargin: types.string,
  children: types.oneOfType([types.element, types.func]).isRequired,

  /**
   * Whether or not the Tether is about to close. Allows you to hook into
   * Tether to display closing animations.
   */
  isClosing: types.bool
}), _defineProperty(_class2, "defaultProps", {
  target: window.document.body,
  distance: '0px',
  offset: '0px',
  arrowMargin: '15px',
  boundary: BOUNDARIES.VIEWPORT,
  autoFlip: true,
  preventOverflow: true,
  arrow: undefined
}), _temp)) || _class);
export default Tether;